import { createFileRoute, redirect } from "@tanstack/react-router";

import { firstIntakeStepId } from "@/lib/routes";

export const Route = createFileRoute("/intake/")({
  beforeLoad: () => {
    throw redirect({
      to: "/intake/$stepId",
      params: { stepId: firstIntakeStepId() },
    });
  },
});
